var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap"},[_c('page-title',[_vm._v(" Reports"),_c('span',{attrs:{"slot":"subtitle"},slot:"subtitle"},[_vm._v("You can view and control reports on all data within BrApp.")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }